module.exports = __webpack_public_path__ + "img/768x768_Zeppelin-Baggerboerse_v2.2e4de731.jpg";